export const login = {
  en: {
    "email.mfa.title": "Verify with email authentication",
    "errors.E0000004": "Incorrect username or password.",
    "password.confirmPassword.placeholder": "Re-enter password",
    "password.confirmPassword.tooltip": "Re-enter password",
    "password.expired.title": "Create a new Okta password",
    "password.expired.title.generic": "Create a new password",
    "password.expired.title.specific": "Create a new {0} password",
    "password.oldPassword.placeholder": "Temporary password",
    "password.oldPassword.tooltip": "Temporary password",
    "primaryauth.title": "Sign in",
    "primaryauth.submit": "Sign in",
  }
};

export const employerLogin = {
  en: {
    "email.mfa.title": "Verify with email authentication",
    "errors.E0000004": "Incorrect username or password.",
    "password.confirmPassword.placeholder": "Re-enter password",
    "password.confirmPassword.tooltip": "Re-enter password",
    "password.expired.title": "Create a new Okta password",
    "password.expired.title.generic": "Create a new password",
    "password.expired.title.specific": "Create a new {0} password",
    "password.oldPassword.placeholder": "Temporary password",
    "password.oldPassword.tooltip": "Temporary password",
    "primaryauth.title": "Manage your company's HSA contributions, employee payroll deductions and employee HSA enrollment.",
    "primaryauth.submit": "Sign in",
    "primaryauth.username.placeholder": "Email Address"
  }
};
